import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { LITERATURE_SOURCES_VDA } from '../../constants';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const VdaScoreLiterature: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const sourcesText = LITERATURE_SOURCES_VDA.join(', ');
  
  const introMath = createMathML(`
    <mrow>
      <mtext>The set L of LITERATURE sources is defined as:</mtext>
    </mrow>
  `, 'inline');

  const setDefinition = createMathML(`
    <mrow>
      <mi>L</mi>
      <mo>=</mo>
      <mo stretchy="true" form="prefix">&#123;</mo>
      <mrow>
        <mi>${sourcesText}</mi>
      </mrow>
      <mo stretchy="true" form="postfix">&#125;</mo>
    </mrow>
  `);

  const pubsDefinition = createMathML(`
    <mrow>
      <msub>
        <mi>N</mi>
        <mrow>
          <mi mathvariant="italic">Pubs</mi>
        </mrow>
      </msub>
      <mspace width="0.222em" />
      <mtext>is the number of publications supporting a VDA from L.</mtext>
    </mrow>
  `, 'inline');

  // Create weight definition based on version
  const weightRows = [];
  
  // if (RELEASE_VERSION === 'v254') {
    weightRows.push(`
      <mtr>
        <mtd><mn>0.4</mn></mtd>
        <mtd>
          <mi>if</mi>
          <mspace width="0.222em" />
          <msub>
            <mi>N</mi>
            <mrow>
              <mi mathvariant="italic">Pubs</mi>
            </mrow>
          </msub>
          <mo>&gt;</mo>
          <mn>99</mn>
          <mspace width="0.222em" />
        </mtd>
      </mtr>
      <mtr>
        <mtd><mn>0.3</mn></mtd>
        <mtd>
          <mi>if</mi>
          <mspace width="0.222em" />
          <mn>9</mn>
          <mo>&lt;</mo>
          <msub>
            <mi>N</mi>
            <mrow>
              <mi mathvariant="italic">Pubs</mi>
            </mrow>
          </msub>
          <mo>≤</mo>
          <mn>99</mn>
          <mspace width="0.222em" />
        </mtd>
      </mtr>
    `);

  // Common rows for all versions
  weightRows.push(`
    <mtr>
      <mtd><mn>0.2</mn></mtd>
      <mtd>
        <mi>if</mi>
        <mspace width="0.222em" />
        <mn>1</mn>
        <mo>&lt;</mo>
        <msub>
          <mi>N</mi>
          <mrow>
            <mi mathvariant="italic">Pubs</mi>
          </mrow>
        </msub>
        <mo>≤</mo>
        <mn>9</mn>
        <mspace width="0.222em" />
      </mtd>
    </mtr>
    <mtr>
      <mtd><mn>0.1</mn></mtd>
      <mtd>
        <mi>if</mi>
        <mspace width="0.222em" />
        <msub>
          <mi>N</mi>
          <mrow>
            <mi mathvariant="italic">Pubs</mi>
          </mrow>
        </msub>
        <mo>=</mo>
        <mn>1</mn>
        <mspace width="0.222em" />
      </mtd>
    </mtr>
    <mtr>
      <mtd><mn>0</mn></mtd>
      <mtd>
        <mi>if</mi>
        <mspace width="0.222em" />
        <msub>
          <mi>N</mi>
          <mrow>
            <mi mathvariant="italic">Pubs</mi>
          </mrow>
        </msub>
        <mo>=</mo>
        <mn>0</mn>
        <mspace width="0.222em" />
      </mtd>
    </mtr>
  `);

  const weightDefinition = createMathML(`
    <mrow>
      <msub>
        <mi>W</mi>
        <mrow>
          <mi mathvariant="italic">L</mi>
        </mrow>
      </msub>
      <mo>=</mo>
      <mrow>
        <mo stretchy="true" form="prefix">&#123;</mo>
        <mtable>
          ${weightRows.join('')}
        </mtable>
      </mrow>
    </mrow>
  `);

  return (
    <div className={className} style={style}>
      <MathMLRenderer mathML={introMath} />
      <MathMLRenderer mathML={setDefinition} />
      <MathMLRenderer mathML={pubsDefinition} className="pl-4" />
      <MathMLRenderer mathML={weightDefinition} />
    </div>
  );
};